var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "container padding-y-md" }, [
        _c(
          "div",
          {
            staticClass:
              "message success with-close with-icon display-flex flex-content-between flex-items-center",
            attrs: { role: "alert" },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative",
              attrs: { icon: _vm.$v7.duotone.faCommentQuestion },
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "button flat compact margin-bottom-0 margin-left-md",
                attrs: {
                  href: "https://fontawesome.typeform.com/survey2026",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v("\n      Take the survey\n      "),
                _c("font-awesome-icon", {
                  staticClass: "margin-left-xs",
                  attrs: { icon: _vm.$v7.solid.faArrowRight },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.dismiss },
              },
              [
                _c("font-awesome-icon", {
                  staticStyle: { "--fa-width": "auto" },
                  attrs: { icon: _vm.$v7.duotone.faCircleXmark },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "margin-0" }, [
      _c("strong", [_vm._v("Help shape Font Awesome's future!")]),
      _vm._v("\n    (And maybe win a lifetime Pro subscription.)\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }